import { BreakpointObserver } from '@angular/cdk/layout';
import { Component } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { MaterialPage } from 'src/app/components/page/material-page.component';
import { SidenavService } from 'src/app/_services/sidenav.service';
import { Router } from '@angular/router';

@Component({
  templateUrl: './why-trust-page.component.html',
  styleUrls: ['./why-trust-page.component.scss']
})
export class WhyTrustPageComponent extends MaterialPage {

  constructor(
    breakpointObserver: BreakpointObserver,
    titleService: Title,
    meta: Meta,
    router: Router,
    sidenavService: SidenavService
  ) {
    super(
      breakpointObserver,
       titleService, 
       meta,
       sidenavService,
       router,
       $localize `:page title:Why trust us`,
       $localize `:page description:We prioritize your trust and security. Listx has successfully completed the CASA Tier 2 requirements.`,
       true);
  }
}
